import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const markdownComponents = {
  p: ({ children }) => <p className="glp1-md-p">{children}</p>,
  ul: ({ children }) => <ul className="glp1-md-list">{children}</ul>,
  ol: ({ children }) => <ol className="glp1-md-list">{children}</ol>,
  li: ({ children }) => <li className="glp1-md-li">{children}</li>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
  code: ({ inline, children }) =>
    inline ? <code className="glp1-md-inline-code">{children}</code> : null,
  pre: () => null,
  img: () => null,
};

export default function MarkdownBody({ children }) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
      {String(children || '')}
    </ReactMarkdown>
  );
}
